<template>
  <div id="page">
    <div class="row topCardGrid" id="cards">
      <sp-card :valor="this.acessoTempo.total" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('acesso.numeroTotal')" :footerText="this.footerTotal">
      </sp-card>
      <sp-card :valor="this.acessoTempo.ano" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('acesso.numeroAno')" :footerText="this.footerAno">
      </sp-card>
      <sp-card :valor="this.acessoTempo.mes" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('acesso.numeroMes')" :footerText="this.footerMes">
      </sp-card>
      <sp-card :valor="this.acessoTempo.semana" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('acesso.numeroSemana')" :footerText="this.footerSemana">
      </sp-card>
    </div>
    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel  :title="$t('acesso.porUsuario')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
          <div class="row">
            <multiselect 
            v-model="valueMult"
            :options="listaFiltro"
            :placeholder="'Filtrar por'"
            @input="multiselectAcesso"
            class="lg6 md6 sm6"/>
          </div>
          <sp360-chart id="" type="vertical-bar" :data="dataAcesso" class="toprow" :options="optionsAcesso" />
          <va-input class="filter-input"
          v-model="termo"
          placeholder="Pesquisar"
          removable
          @input="pesquisa"
          />
          <sp360-data-table class="flex" v-show="true" id="tabelaDeAcesso" ref="tabelaDeAcesso"
          :apiMode="false"
          :data="tabelaAcesso.dadosFiltrados"
          :fields="tabelaAcesso.fields"
          :perPage="tabelaAcesso.itemsPerPage"
          :onEachSide="1"
          :striped="true"
          :clickable="false"
          @row-clicked="clickedOrgao"
          />
        </sp-360-panel> 
      </div>
      <div class="flex col md12 sm12">
        <sp-360-panel  :title="$t('acesso.diario')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})" class="content">
          <multiselect 
          v-model="valueMult"
          :options="listaFiltro"
          :placeholder="$t('Filtrar por')"
          @input="multiselectAcessoDia"
          class="lg6 md6 sm6"/>
          <sp360-chart id="" type="vertical-bar" :data="dataAcessDia" class="toprow" :options="optionsAcessoDia" />
        </sp-360-panel> 
      </div>
    </div>
  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import Overlay from '@/assets/geojson/spoverlay'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Legenda from '@/components/maps/360-maps/Legenda'


export default {
  name: 'relatorio-acessos',
  mixins: [Overlay, Legenda],
  components: {
    SpCard,
    Multiselect,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
  },

  data () {
    return {
      dataRef: new Date(),
      fonte: '',
      coagulado: 0,
      dataAcesso: {},
      dataAcessDia: {},
      seletorEscolaridade: 0,
      DataUsuarioLista:{},
      acessoTempo:{total: 0, ano: 0,mes: 0, semana: 0},
      valueMult: 'Desde Sempre',
      optionsAcesso: [],
      optionsAcessoDia: [],
      termo: "",
      clickedOrgao: "",
      dataSelect: '',
      footerTotal: '',
      footerAno: '',
      footerMes: '',
      footerSemana: '',

      listaFiltro: [
        "Desde Sempre", 
        "Últimos 7 Dias", 
        "Último Mês" ,
        "Últimos 30 Dias", 
        "Último Semestre" , 
        "Últimos 180 Dias", 
        "Último Ano",
        "Últimos 365 Dias"
      ],

      contratacaoPorOrgao: [],

      tabelaAcesso: {
        data: [],
        dadosFiltrados: [],
        itemsPerPage: 9,
        fields: [
          {
            name: 'nome',
            sortField: 'nome',
            title: 'nome',
            width: '70%'
          },
          {
            name: 'acesso',
            sortField: 'acesso',
            title: 'acessos',
            width: '30%',
            callback: MethGlob.thousandSeparator,
          },
        ],
        sortFunctions: {
          'nome': MethGlob.ordenaTabela,
          'total': MethGlob.ordenaTabelaParseInt,
        },  
      },
    }
  },

  created () {

    Promise.all([
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', {}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimo_ano'}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimos_365_dias'}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimo_semestre'}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimos_180_dias'}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimo_mes'}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimos_30_dias'}),
      this.$store.dispatch('sp360Analytics/dadosDeAcessosNoIntervalo', { intervalo: 'ultimos_7_dias'}),
      this.$store.dispatch('usuario/getAllUsuario', {}),
      
    ]).then(respostas => {
        this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
        this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
        this.cores = _.shuffle(CorUtils.getVetorCoresPorTom('medio'))
        this.fonte = respostas[0].data.fonte;

        

        this.optionsAcesso = {
          legend:
          {
            display: false,
          },
          responsive: true,
          tooltips: {
            callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 40,
              bottom: 40,
            },
            margin: 100,
          },
          plugins: {
            datalabels: {
              formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map(data => {
                  sum += data
                })
                let percentage = MethGlob.thousandSeparator(parseFloat(value))
                return percentage
              },
              color: '#000',
              display: 'auto',
              labels: {
                value: {
                  font: {
                    weight: 'bold',
                  },
                },
              },
            },
          },
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
              },
              ticks: {
                beginAtZero: true,
                autoSkip: false,
              },
            }],
            yAxes: [{
              scaleLabel: {
                display: true,
              },
              ticks: {
                callback: function (value) {
                  return MethGlob.thousandSeparator(value)
                },
              },
            }],
          },
        }

        this.optionsAcessoDia = {
          legend:
          {
            display: false,
          },
          responsive: true,
          tooltips: {
            callbacks: MethGlob.percentualLabelCallback(false, true, 'donut'),
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 40,
              bottom: 40,
            },
            margin: 100, 
          },
          plugins: {
            datalabels: {
              formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map(data => {
                  sum += data
                })
                let percentage = MethGlob.thousandSeparator(parseFloat(value))
                return percentage
              },
              color: '#000',
              display: 'auto',
              labels: {
                value: {
                  font: {
                    weight: 'bold',
                  },
                },
              },
            },
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                autoSkip: true,
                callback: value => new Date(value).toLocaleDateString("pt-BR"),
              },
            }],
          },
        }

        this.dataAcesso = this.montarGraficoAcesso(respostas[0].data.data)

        this.dataSelect = [ respostas[0].data.data,
                            respostas[1].data.data,
                            respostas[2].data.data,
                            respostas[3].data.data,
                            respostas[4].data.data,
                            respostas[5].data.data,
                            respostas[6].data.data,
                            respostas[7].data.data  ],

        this.dataAcessDia = this.montarGraficoAcessoDia(respostas[0].data.data) 
        this.tabelaAcesso.dadosFiltrados = _.orderBy(this.DataUsuarioLista, 'nome')

        this.multiselectAcesso()

        respostas[0].data.data.forEach( e => 
        {
          this.acessoTempo.total += e.acessos;
        });

        respostas[1].data.data.forEach( e => 
        {
          this.acessoTempo.ano += e.acessos;
        });

        respostas[6].data.data.forEach( e => 
        {
          this.acessoTempo.mes += e.acessos;
        });

        respostas[7].data.data.forEach( e => 
        {
          this.acessoTempo.semana += e.acessos;
        });

        this.footerTotal =  'Contabilizado desde: ' + this.dataPTBR(this.acessoTempo.total,   this.dataSelect[0][0].data);
        this.footerAno =    'Contabilizado desde: ' + this.dataPTBR(this.acessoTempo.ano,     this.dataSelect[1][0].data);
        this.footerMes =    'Contabilizado desde: ' + this.dataPTBR(this.acessoTempo.mes,     this.dataSelect[6][0].data);
        this.footerSemana = 'Contabilizado desde: ' + this.dataPTBR(this.acessoTempo.semana,  this.dataSelect[7][0].data);
    })
  },

  methods: {
    pesquisa: _.debounce(function (term) {
      this.termo = term
      let a = []
      if ((!Number.isNaN(parseInt(term))) && term != '') {
        a = this.$refs.tabelaDeAcesso.filterByNumber(this.dados.data, this.termo)
      } else {
        a = this.$refs.tabelaDeAcesso.filterByString(this.tabelaAcesso.data, this.termo)
      }
      this.tabelaAcesso.dadosFiltrados = _.orderBy(a, 'nome')
    }, 400),

    dataPTBR(total, data){
      let dia = new Date(data).toLocaleDateString("pt-BR");
      if(total > 0)return dia;
      else return NaN;
    },

    multiselectAcessoDia(value){
      let seletor; 
      switch (value) 
      {
        case 'Desde Sempre':
        seletor = this.dataSelect[0];
        break;
        case 'Último Ano':
        seletor = this.dataSelect[1];
        break;
        case 'Últimos 365 Dias':
        seletor = this.dataSelect[2];
        break;
        case 'Último Semestre':
        seletor = this.dataSelect[3];
        break;
        case 'Últimos 180 Dias':
        seletor = this.dataSelect[4];
        break;
        case 'Último Mês':
        seletor = this.dataSelect[5];
        break;
        case 'Últimos 30 Dias':
        seletor = this.dataSelect[6];
        break;
        case 'Últimos 7 Dias':
        seletor = this.dataSelect[7];
        break;
        default:
        seletor = this.dataSelect[0];
      }
      this.dataAcessDia =  this.montarGraficoAcessoDia(seletor);
    },

    multiselectAcesso (value) {
      let seletor;
      switch (value) 
      {
        case 'Desde Sempre':
        seletor = this.dataSelect[0];
        break;
        case 'Último Ano':
        seletor = this.dataSelect[1];
        break;
        case 'Últimos 365 Dias':
        seletor = this.dataSelect[2];
        break;
        case 'Último Semestre':
        seletor = this.dataSelect[3];
        break;
        case 'Últimos 180 Dias':
        seletor = this.dataSelect[4];
        break;
        case 'Último Mês':
        seletor = this.dataSelect[5];
        break;
        case 'Últimos 30 Dias':
        seletor = this.dataSelect[6];
        break;
        case 'Últimos 7 Dias':
        seletor = this.dataSelect[7];
        break;
        default:
        seletor = this.dataSelect[0];
      }
      this.dataAcesso =  this.montarGraficoAcesso(seletor);
    },

    montarGraficoAcesso(dados) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        backgroundColor: CorUtils.getCorPorNomeSp360('verde-limao-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          anchor: 'end',
          align: 'end',
          display: 'auto',
        },
      }

      let usuarioLista = [];
      let listaTemporaria = dados;
      let item = null;

      listaTemporaria.forEach(e =>{
        item = usuarioLista.find(x => e.nome === x.nome)
        if(item){
          item.acesso += e.acessos
        }else{
          usuarioLista.push({ acesso: e.acessos , nome: e.nome})
        }
      })

      usuarioLista.sort((a, b) => {
        if (a.acesso > b.acesso) {return -1;}
        if (a.acesso < b.acesso) {return 1;}
        return 0;
      });

       usuarioLista.forEach(e => {
        if (e.acesso > 0) 
        {
          chartData.labels.push(e.nome)
          dataset.data.push(e.acesso)
        }
      })

      this.DataUsuarioLista = usuarioLista;
      this.tabelaAcesso.dadosFiltrados = _.orderBy(this.DataUsuarioLista, 'nome');
      this.tabelaAcesso.data = _.orderBy(this.DataUsuarioLista, 'nome');
      chartData.datasets.push(dataset)
      return chartData
    },

    montarGraficoAcessoDia(dados){
    let chartData = { datasets: [], labels: [] }
    let dataset = {
      backgroundColor: CorUtils.getCorPorNomeSp360('verde-limao-medio'),
      borderColor: this.$store.getters.palette.transparent,
      data: [],
      datalabels: {
        color: CorUtils.getCorPorNomeSp360('preto-escuro'),
        anchor: 'end',
        align: 'end',
        display: 'auto',
      },
    }

    let acessoLista = [];
    let item = null;

    dados.forEach(e =>{
      item = acessoLista.find(x => e.nome === x.nome)
      if(item){
        item.acesso += e.acessos
      }else{
        acessoLista.push({ acesso: e.acessos , data: e.data})
      }
    })

    acessoLista.forEach(e => {
      chartData.labels.push(e.data)
      dataset.data.push(e.acesso)
    });

    chartData.datasets.push(dataset)
    return chartData
    },  
  }, 
}
</script>

<style lang='scss' scoped>
  ::v-deep .red{
    background-color: #40e583;
  }
  #tabelaDeAcesso{
    padding:0;
    padding-bottom: 20px;
  }
  .toprow{
    max-height: 30rem
  }
  .content{
    height: 100%
  }
  .content::v-deep .va-card__footer{ 
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .va-card__body{
    height: 100%;
  }
</style>
